// extracted by mini-css-extract-plugin
module.exports = {"modal-close-button":"style_modal-close-button__mi2eW","modal-close-button__icon":"style_modal-close-button__icon__MiYjf"};